import { MAPBOX_TOKEN } from "../config";

export interface ICoords {
  lat: number;
  lng: number;
}

// cache em memória: evita geocodificar o mesmo endereço mais de uma vez por sessão
const cache = new Map<string, ICoords | null>();

export const geocodeAddress = async (query: string): Promise<ICoords | null> => {
  const key = query.trim().toLowerCase();

  if (cache.has(key)) return cache.get(key) ?? null;

  try {
    const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(
      query
    )}.json?access_token=${MAPBOX_TOKEN}&country=BR&limit=1&language=pt`;

    const res = await fetch(url);
    const data = await res.json();
    const center = data?.features?.[0]?.center;

    const coords = center ? { lng: center[0], lat: center[1] } : null;
    cache.set(key, coords);
    return coords;
  } catch {
    // não cacheia erro de rede: permite nova tentativa na próxima renderização
    return null;
  }
};
